import Vue from "vue"
import { eventListeners } from "@evercam/ui"

if (!Vue.__eventListeners_mixin__) {
  // See https://nuxtjs.org/docs/directory-structure/plugins/#global-mixins
  Vue.__eventListeners_mixin__ = true

  Vue.mixin(eventListeners)
}
